// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#realNameDialog .el-dialog__body {\n  padding: 12px 20px 40px 20px;\n}\n#realNameDialog .demo-ruleForm .el-form-item--small.el-form-item {\n  width: 400px;\n  margin: 0 auto 18px auto;\n}\n#realNameDialog .demo-ruleForm .name-input .el-input {\n  width: 250px;\n}\n#realNameDialog .demo-ruleForm .form-btn {\n  display: block;\n  margin-left: 0;\n  margin-top: 40px !important;\n  text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
